import { UseQueryOptions } from 'react-query'
import { Props, Data, useBrandVisualAnalysis } from './useBrandVisualAnalysis'

interface Options extends Omit<UseQueryOptions<Data>, 'refetchInterval'> {
  intervalMs?: number
}

export const usePollBrandVisualAnalysis = (props: Props, options?: Options) => {
  return useBrandVisualAnalysis(props, {
    refetchInterval: (data) => {
      const status = data?.brand_visual_analysis?.status
      if (!status || ['successful', 'aborted', 'failed'].includes(status)) {
        return false
      }

      return options?.intervalMs || 500
    },
    ...options,
  })
}
